import { render, staticRenderFns } from "./TaskItemContainer.vue?vue&type=template&id=2c559d79&scoped=true&"
import script from "./TaskItemContainer.vue?vue&type=script&lang=js&"
export * from "./TaskItemContainer.vue?vue&type=script&lang=js&"
import style0 from "./TaskItemContainer.vue?vue&type=style&index=0&id=2c559d79&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c559d79",
  null
  
)

export default component.exports